import dynamic from "next/dynamic";
const BackgroundImageCardsGridComponent = dynamic(()=>import("./background-image-cards-grid-component"));
import BackgroundImageCardsGridConfig from "./background-image-cards-grid-config";
import BackgroundImageCardsGridAdvancedConfig from "./background-image-cards-grid-advanced-config";
export default {
    BackgroundImageCardsGridComponent,
    BackgroundImageCardsGridConfig,
    BackgroundImageCardsGridAdvancedConfig
};
